import { useCallback } from 'react';

import type { Content } from '../types';

import { useSendContentCompletedEvent } from '../../../hooks';
import { getSecondsCompletionPercent, useSecondConsumed } from '../../media-lifecycle-hooks';
import { useMediaPlayer } from '../../MediaPlayerProvider';
import { extractContentId } from '../content-utils';

export function useOnSecondConsumedAnalytics({ content }: { content: Content }) {
  const contentId = extractContentId(content);

  const { onCompletionPercent } = useSendContentCompletedEvent({ contentId });

  const { player } = useMediaPlayer();

  const secondConsumedHandler = useCallback(() => {
    if (player !== null) {
      const secondsCompletionPercent = getSecondsCompletionPercent(player);
      onCompletionPercent(secondsCompletionPercent);
    }
  }, [onCompletionPercent, player]);

  useSecondConsumed(secondConsumedHandler);
}
